export const DELETE_DASHBOARD_NAME = "delete_dashboard";
export const DELETE_DASHBOARD_DESC = `Deletes a workspace dashboard via the DeleteDashboard GraphQL mutation.

Use when the user explicitly wants to remove a dashboard. Always confirm before executing because this operation is destructive.

Input:
- 'dashboardId' (required): Dashboard ID (GraphQL global ID) to delete. Obtainable from the dashboard URL or listing tools.

Output:
- Returns only the deleted dashboard ID.

Notes:
- Write operation; always run through confirmation UI.
- If the ID is invalid or the dashboard no longer exists, return an error so the user can refresh the view.`;
